export function withAuthToken(url) {
  if (!url) return url;

  const token = localStorage.getItem('ca_token');
  if (!token) return url;

  if (/token=/.test(url)) return url;

  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}token=${encodeURIComponent(token)}`;
}
